{
  "permission": {
    "actions": {
      "edit": {},
      "remove": {}
    },
    "full": {},
    "grant": {},
    "name": {},
    "read": {},
    "type": {},
    "write": {}
  }
}
